import { useState, useEffect } from "react";
import "./FilterSidebar.css";
import CategoryTree from "../category/CategoryTree";
import PriceRange from "../range/PriceRange";
import axios from "../../utils/axiosInstance";
const FilterSidebar = ({ brands, categoryId, applyFilters }) => {
  const [isOpen, setIsOpen] = useState(false); // کنترل سایدبار
  const [openSections, setOpenSections] = useState({}); // کنترل باز/بسته بودن بخش‌ها
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedAttributes, setSelectedAttributes] = useState({});

  const [attributes, setAttributes] = useState([]);
  const handleFilterPrice = () => {};
  const handleBrandChange = (e) => {
    const value = e.target.id;
    console.log("brand", value);
    setSelectedBrands((prev) =>
      e.target.checked ? [...prev, value] : prev.filter((b) => b !== value)
    );
      console.log("brand", selectedBrands);
  };
  const handleAttributeChange = (attrName, option, checked) => {
    setSelectedAttributes((prev) => {
      const current = prev[attrName] || [];
      if (checked) {
        return { ...prev, [attrName]: [...current, option] };
      } else {
        return { ...prev, [attrName]: current.filter((o) => o !== option) };
      }
    });
  };

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section], // باز و بسته کردن
    }));
  };
  useEffect(() => {
    if (!categoryId) return;
    axios.get(`/categories/${categoryId}`).then((res) => {
      const attrs = res.data.data.attributes || [];
      // فقط Attributeهای قابل فیلتر
      setAttributes(attrs.filter((a) => a.isFilterable));
    });
  }, [categoryId]);

  return (
    <>
      {/* دکمه برای موبایل */}
      <button
        className="btn btn-outline-primary fs-5 d-lg-none btn-lg pe-5 ps-5"
        onClick={() => setIsOpen(true)}
      >
        Filter
      </button>

      {/* پس‌زمینه تیره موبایل */}
      {isOpen && (
        <div className="overlay" onClick={() => setIsOpen(false)}></div>
      )}

      {/* سایدبار */}
      <div
        className={`filter-sidebar card m-5 shadow-sm ${isOpen ? "open" : ""}`}
      >
        <div className="filter-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Filters</h5>
          <button
            className="btn-close d-lg-none"
            onClick={() => setIsOpen(false)}
          ></button>
        </div>
        <hr />
        {/* دسته‌بندی */}
        <div className="filter-section">
          <div
            className="filter-title d-flex justify-content-between align-items-center"
            onClick={() => toggleSection("category")}
          >
            <h6 className="mb-0">Category</h6>
            <span className={`arrow ${openSections.category ? "open" : ""}`}>
              ▼
            </span>
          </div>
          {openSections.category && (
            <div className="filter-content p-3 border rounded mt-2">
              <CategoryTree />
            </div>
          )}
        </div>
        <hr />
        {/* برند */}
        <div className="filter-section">
          <div
            className="filter-title d-flex justify-content-between align-items-center"
            onClick={() => toggleSection("brand")}
          >
            <h6 className="mb-0">Brand</h6>
            <span className={`arrow ${openSections.brand ? "open" : ""}`}>
              ▼
            </span>
          </div>
          {openSections.brand && (
            <div className="brand-list border rounded p-2">
              <div className="brand-scroll">
                {brands.map((brand) => (
                  <div key={brand._id} className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={brand.name}
                      id={`${brand._id}`}
                      onChange={handleBrandChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`brand-${brand._id}`}
                    >
                      {brand.name}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <hr />
        {/* محدوده قیمت */}
        <div className="filter-section">
          <div
            className="filter-title d-flex justify-content-between align-items-center"
            onClick={() => toggleSection("price")}
          >
            <h6 className="mb-0">Price range</h6>
            <span className={`arrow ${openSections.price ? "open" : ""}`}>
              ▼
            </span>
          </div>
          {openSections.price && (
            <PriceRange setMaxPrice={setMaxPrice} setMinPrice={setMinPrice} />
          )}
          <hr />
        </div>{" "}
        {attributes.map((attr) => (
          <div className="filter-section" key={attr._id}>
            <div
              className="filter-title d-flex justify-content-between align-items-center"
              onClick={() => toggleSection(attr.name)}
            >
              <h6 className="mb-0">{attr.name}</h6>
              <span
                className={`arrow ${openSections[attr.name] ? "open" : ""}`}
              >
                ▼
              </span>
            </div>

            {openSections[attr.name] && (
              <div
                className="filter-options border rounded p-2 mt-2"
                style={{ maxHeight: "180px", overflowY: "auto" }}
              >
                {attr.type === "select" &&
                  attr.options.map((option, i) => (
                    <div key={i} className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`${attr._id}-${i}`}
                        value={option}
                        onChange={(e) =>
                          handleAttributeChange(
                            attr.name,
                            option,
                            e.target.checked
                          )
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`${attr._id}-${i}`}
                      >
                        {option}
                      </label>
                    </div>
                  ))}

                {attr.type === "boolean" && (
                  <>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`${attr._id}-yes`}
                        value="true"
                        onChange={(e) =>
                          handleAttributeChange(
                            attr.name,
                            "Yes",
                            e.target.checked
                          )
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`${attr._id}-yes`}
                      >
                        Yes
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`${attr._id}-no`}
                        value="false"
                        onChange={(e) =>
                          handleAttributeChange(
                            attr.name,
                            "No",
                            e.target.checked
                          )
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`${attr._id}-no`}
                      >
                        No
                      </label>
                    </div>
                  </>
                )}
              </div>
            )}
            <hr />
          </div>
        ))}
        <button
          className="btn btn-primary w-100 mt-3"
          onClick={() =>
            applyFilters(
              categoryId,
              selectedBrands,
              minPrice,
              maxPrice,
              selectedAttributes
            )
          }
        >
          Apply Filters
        </button>
      </div>
    </>
  );
};

export default FilterSidebar;
